<template>
  <img :src="iconSrc" class="icon-size-16" :alt="alt" />
</template>

<script>
const ICONS = {
  proforma: '/img/icons/ProFormEdit.svg',
  forecast: '/img/icons/ForeCastEdit.svg',
};

export default {
  name: 'EditIcon',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['proforma', 'forecast'].includes(value),
    },
    alt: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconSrc() {
      return ICONS[this.type];
    },
  },
};
</script>

<style scoped>
.icon-size-16 {
  width: 16px;
  height: 16px;
}
</style>
